var _circle, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRainCity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    fill: "#222222",
    r: 12
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#2d2d2d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m11.5383 7.79058c-.2802 0-.467-.18682-.467-.46705v-.93411c0-.28023.1868-.46706.467-.46706.2803 0 .4671.18683.4671.46706v.93411c0 .28023-.1868.46705-.4671.46705z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.371 18.9999c-.88738 0-1.63467-.7473-1.63467-1.6347 0-.2802.18682-.467.46705-.467.28024 0 .46706.1868.46706.467 0 .3737.32693.7006.70056.7006.3737 0 .7006-.3269.7006-.7006v-3.9699c0-.2803.1868-.4671.4671-.4671.2802 0 .467.1868.467.4671v3.9699c0 .8874-.7473 1.6347-1.6347 1.6347z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.2747 11.5271c-1.3077 0-2.3352-1.0275-2.3352-2.33529 0-1.12093 1.6346-3.54961 1.9616-4.01666.1868-.23353.6072-.23353.7473 0 .3269.46705 1.9616 2.89573 1.9616 4.01666 0 1.30779-1.0275 2.33529-2.3353 2.33529z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.2752 12.4611c-1.8215 0-3.2694-1.4479-3.2694-3.26938 0-.60717.327-1.40117.7006-2.24186-.3736-.04671-.7473-.09341-1.1676-.09341-3.59636 0-6.5388 2.94244-6.5388 6.53875 0 .2802.18682.4671.46705.4671h12.14345c.2802 0 .467-.1869.467-.4671 0-.7006-.0934-1.4012-.3269-2.055-.6072.7005-1.4946 1.1209-2.4754 1.1209z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRainCity);
export default __webpack_public_path__ + "static/media/rain_city.ce03bde4b19d80f61cd0316d59f3dbab.svg";
export { ForwardRef as ReactComponent };